const APP_URL = config.appUrl;
const APP_URL_ENCODED = encodeURIComponent(APP_URL);
const EMBED_URL = config.embedUrl;
const SHARING_TEXT_ENCODED = encodeURIComponent(config.sharingText);
const SHARING_URL = config.sharingUrl;
const SHARING_URL_ENCODED = encodeURIComponent(SHARING_URL);

export function getHrefFb() {
  return `https://www.facebook.com/sharer/sharer.php?u=${SHARING_URL_ENCODED}&t=${SHARING_TEXT_ENCODED}`;
}

export function getHrefTw() {
  return `https://twitter.com/intent/tweet?url=${SHARING_URL_ENCODED}&text=${SHARING_TEXT_ENCODED}`;
}

export function getEmbedCode() {
  return `
  <script>document.addEventListener&&window.addEventListener("message",e=>{if(e.data.hasOwnProperty("idwBerufeFrameHeight")){var t=document.getElementById("idw-frame-berufe");t&&(t.style.height=e.data.idwBerufeFrameHeight+"px")}});</script><iframe id="idw-frame-berufe" width="100%" height="960" src="${EMBED_URL}" frameborder="0" allowfullscreen></iframe>
  `;
}

export default {
  getEmbedCode,
  getHrefFb,
  getHrefTw,
};
